import { Tooltip } from "../../../../../UI";
import { StyledIconContainer } from "../../Sidebar-styled";
import { DropdownContainer, DropdownItem } from "./SidebarDropdown-styled";

const SidebarDropdown = ({ options, children, ...props }) => {
  const content =
    children ||
    options.map((option) =>
      !!option.description ? (
        <Tooltip
          key={option.title}
          content={option.description}
          placement="right"
          delay={1000}
          disabled={!option.description || option.disabled}
          wrapperStyles={{ width: "100%" }}
          showOnHover
          blurred
        >
          <DropdownItem
            disabled={option.disabled}
            selected={option.selected}
            onClick={option.onClick}
            key={option.title}
            style={{ width: "100%", boxSizing: "border-box" }}
          >
            <StyledIconContainer selected={option.selected}>
              {option.icon}
            </StyledIconContainer>
            <span>{option.title}</span>
          </DropdownItem>
        </Tooltip>
      ) : (
        <DropdownItem
          disabled={option.disabled}
          selected={option.selected}
          onClick={option.onClick}
          key={option.title}
          style={{ width: "100%", boxSizing: "border-box" }}
        >
          <StyledIconContainer selected={option.selected}>
            {option.icon}
          </StyledIconContainer>
          <span>{option.title}</span>
        </DropdownItem>
      )
    );

  return (
    <Tooltip
      wrapperStyles={{
        width: "auto",
        height: "100%",
        position: "absolute",
        right: 0,
        top: 0,
      }}
      content={<DropdownContainer>{content}</DropdownContainer>}
      alignWithTriggerTop
      visible
      blurred
      placement="right"
      padding={4}
      offset={16}
      showOnClick
      {...props}
    >
      <div
        style={{
          width: "auto",
          height: "100%",
          position: "absolute",
          right: 0,
          top: 0,
        }}
      ></div>
    </Tooltip>
  );
};

export default SidebarDropdown;
